import React from "react";
import { Helmet } from "react-helmet";

import PasswordStyles from "views/open/ResetPassword.module.scss";
import { ResetPasswordForm } from "components/login/ResetPasswordForm";

export const ResetPassword = () => {
  return (
    <div id={"gb-open"}>
      <Helmet>
        <title>Minha Glambox : Recuperação de Senha</title>
      </Helmet>
      <div className={PasswordStyles["reset"]}>
        <div className={PasswordStyles["reset__info"]}>
          <h5>Olá Glamgirl,</h5>
          <p>Se você esqueceu a sua senha, não tem problema. Por favor, nos diga o e-mail da sua conta para iniciar o processo.</p>
        </div>
        <div className={PasswordStyles["reset__form"]}>
          <h5>Redefinição de senha</h5>

          <ResetPasswordForm/>
        </div>
      </div>
    </div>
  );
};